.input-container {
  box-sizing: border-box;
  border: 2px dashed;
  border-color: var(--dds-color-border-default);
  background-color: var(--dds-color-surface-default);
  border-radius: var(--dds-border-radius-surface);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state);
  }
}

.input-container--with-errors {
  border-color: var(--dds-color-border-danger);
}

.input-container--drag-active {
  border-color: var(--dds-color-border-action-hover);
  background-color: var(--dds-color-surface-hover-default);
}

.file--invalid {
  box-shadow: inset 0 0 0 1px var(--dds-color-border-danger);
}

.file__icon--invalid {
  color: var(--dds-color-icon-on-danger-default);
}

.file__icon--valid {
  color: var(--dds-color-icon-on-success-default);
}

.file__name {
  word-break: break-all;
  width: 100%;
}

.readonly--file-list {
  @media (prefers-reduced-motion: no-preference) {
    transition: var(--dds-focus-transition);
  }
}
